import TileLayer from 'ol/layer/Tile.js';
import VectorLayer from 'ol/layer/Vector.js';
import OSM from 'ol/source/OSM';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import LayerGroup from 'ol/layer/Group';
import TileWMS from 'ol/source/TileWMS';
import {WMS_Sources} from './wms_sources';
import {Circle as Circle, Fill, Style, Icon, Stroke, Text} from 'ol/style';
import GML3 from 'ol/format/GML3';
import {transformExtent} from 'ol/proj';

import {TileArcGISRest} from 'ol/source';
import EsriJSON from 'ol/format/EsriJSON';
import {bbox as bboxStrategy} from 'ol/loadingstrategy';
import {tile as tileStrategy} from 'ol/loadingstrategy';
import {createXYZ} from 'ol/tilegrid';

import Projection from 'ol/proj/Projection';
import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';

import vineyards from './vineyards.geojson';
import vineyard_icon from './grapes.png';

proj4.defs("EPSG:3794","+proj=tmerc +lat_0=0 +lon_0=15 +k=0.9999 +x_0=500000 +y_0=-5000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs");	// slovenia
proj4.defs("EPSG:6706","+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs");	//	italia cadastre
register(proj4);

/** URL GET - page profile **/

var profile_settings = [
	{"extent": [1300000, 5700000, 1600000, 5826000]},	//profile 0 - default
	{"extent": [1300000, 5400000, 1900000, 8000000]}	//profile 1
];

function read_get(){
	const urlParams = new URLSearchParams(window.location.search); 
	const get_profile = urlParams.get('profile');
	
	return (get_profile == null) ? 0 : get_profile;
}

var page_profile = read_get();

/** end of URL GET **/


var projection = new Projection({
  code: 'EPSG:3794',
  extent: [373217.65,32395.09,622710.74,194645.86],
});

var projection_it_1 = new Projection({
  code: 'EPSG:6706',
  extent: [5.93,34.76,18.99,47.1],
});

/* OSM layer */
const osm = new TileLayer({
    title: 'OpenStreetMap',
    source: new OSM(),
	visible:true,
});
osm.id = "OSM";

// set default time
var date1 = new Date();
var date2 = new Date();
date2.setDate(date1.getDate() - 30);	// one month
var time1 = date2.getFullYear()+"-"+(date2.getMonth()+1)+"-"+date2.getDate()+"/"+date1.getFullYear()+"-"+(date1.getMonth()+1)+"-"+date1.getDate();

// Add Sentinel layers
let sources = new WMS_Sources();
let sentinelLayers = sources.getSentinelHubTileLayers();
let sentinelOpenlayersLayers = [];

sentinelLayers.forEach(function(layer){
	
	let params = layer.params;
	params.urlProcessingApi = layer.url;
	params.time = time1;
	
	// let True Color be visible
	let visib = (layer.title == 'Natural Color (True Color)');
	
	let tile = new TileLayer({
		visible: visib,
		title: layer.title,
		source: new TileWMS({
			url: layer.url,
			params:params,
			serverType: 'geoserver',
			transition: 0
		}),
	});
	
	tile.id = layer.id;
	
	sentinelOpenlayersLayers.push(tile);
});
exports.sentinelLayers = sentinelOpenlayersLayers;


/* VINEYARDS */

var image = new Circle({
  radius: 5,
  fill: null,
  stroke: new Stroke({color: 'red', width: 1}),
  fill: new Fill({
              color: 'purple'
          })
});

var image2 = new Icon({
	src:vineyard_icon, 
	scale: 0.012 
});

var style = new Style({
    image: image2,
	text: new Text({
		//font: '12px Calibri,sans-serif',
		font: '12px Lucida Sans Unicode, Lucida Grande, sans-serif',
		fill: new Fill({
		  color: '#000',
		}),
		stroke: new Stroke({
		  color: 'yellow',
		  width: 3,
		}),
		offsetY: 30,
	  }),
  });



/*
var vectorSourceVineyard = new VectorSource({
  features: new GeoJSON().readFeatures(vineyards),
});
*/

let vineyardsLayer = new VectorLayer({  
  title: "Vineyards",
  //source: vectorSourceVineyard,
  style: function (feature) {
    style.getText().setText(feature.get('name'));
    return style;
  },
  source: new VectorSource({
      format: new GeoJSON(),
      url: vineyards,
	  projection: 'EPSG:4326',
  }),
  //style: new Style({ image: new Icon({ src:"./grapes.png", scale: 0.8 }) })
  /*style: new Style({
      image: new Circle( ({
          radius: 5,
          fill: new Fill({
              color: 'purple'
          })
      }))
  })*/
});

vineyardsLayer.id = "vineyards";

/* WMS */

const dof5 = new TileLayer({
  visible: true,
  title: "SI - Orthophoto, 0,5m",
  source: new TileWMS({
	url: "https://storitve.eprostor.gov.si/ows-pub-wms/SI.GURS.ZPDZ/wms",
    params: {
      'layers': 'DOF5',
    },
	projection: 'EPSG:3794',
	//projection:projection,
  })
});

dof5.id = "orthophoto_si";

/*
const dof5 = new TileLayer({
  visible: false,
  title: "Orthophoto, 0,5m",
  source: new TileWMS({
	url: "https://prostor4.gov.si/ows2-m-pub/wms",
    params: {
      'layers': 'SI.GURS.ZPDZ:DOF050',
    },
	projection: 'EPSG:3794',
	//projection:projection,
  })
});


const dof5_alternative = new TileLayer({
  visible: false,
  title: "Orthophoto, 0,5m (2)",
  source: new TileWMS({
	url: "https://storitve.eprostor.gov.si/ows-ins-wms/ows?SERVICE=WMS",
    params: {
      'layers': 'oi:OI.OrthoimageCoverage',
    },
	projection: 'EPSG:3794',
	//projection:projection,
  })
});

// ESRI DOF
let url_dof = 'https://gisserver.gov.si/arcgis/rest/services/TEMELJNE_KARTE/DOF2019/MapServer';

const dof5_alternative2 = new TileLayer({
	visible: false,
	title: "Orthophoto, 0,5m (3)",
    source: new TileArcGISRest({      
	  url: url_dof,
	  params: {
		  'layers': 'show:0',
		},
	  projection: 'EPSG:3857',
    }),
  });

const gerk = new TileLayer({
  visible: false,
  title: "Agricultural holdings (KMRS)",
  source: new TileWMS({
	url: "https://storitve.eprostor.gov.si/ows-pub-wms/SI.MKGP.KMRS/ows",
    params: {
	  'layers':'ZV_KRMS',
    },
	projection: 'EPSG:3794',
  })
});
*/

const gerk2 = new TileLayer({
  visible: false,
  title: "Agricultural holdings (raster)",
  minZoom: 15,
  source: new TileWMS({
	url: "https://storitve.eprostor.gov.si/ows-pub-wms/SI.MKGP.GERK/ows", 
    params: {
	  'layers':'RKG_BLOK_GERK',
    },
	projection: 'EPSG:3794',
  })
});

gerk2.id = "gerk_si";

// geoserver gerk mask
const gerk_mask = new TileLayer({
  visible: false,
  title: "Vineyards mask",
  source: new TileWMS({
	url: "https://app.gis.si/geoserver/GINST/wms?service=WMS",
    params: {
	  'layers':'GINST:maska_slo_it_all',
    },
	projection: 'EPSG:3794',
  })
});

gerk_mask.id = "mask";

// geoserver slope
const slope = new TileLayer({
  visible: false,
  title: "Slope",
  source: new TileWMS({
	url: "https://app.gis.si/geoserver/GINST/wms?service=WMS",
    params: {
	  'layers':'GINST:slope',
    },
	projection: 'EPSG:3794',
  })
});

slope.id = "slope";

const slope_reclass = new TileLayer({
  visible: false,
  title: "Slope (classified)",
  source: new TileWMS({
	url: "https://app.gis.si/geoserver/GINST/wms?service=WMS",
    params: {
	  'layers':'GINST:slope_reclass',
    },
	projection: 'EPSG:3794',
  })
});

slope_reclass.id = "slope_class";

//geoserver hillshade
const hillshade = new TileLayer({
  visible: false,
  title: "Hillshade",
  source: new TileWMS({
	url: "https://app.gis.si/geoserver/GINST/wms?service=WMS",
    params: {
	  'layers':'GINST:sence',
    },
	projection: 'EPSG:3794',
  })
});

hillshade.id = "hillshade";

//geoserver irradiation
const irradiation = new TileLayer({
  visible: false,
  title: "Mean integrated daily irradiation",
  source: new TileWMS({
	url: "https://app.gis.si/geoserver/GINST/wms?service=WMS",
    params: {
	  'layers':'GINST:mean integrated daily irradiaton',
    },
	projection: 'EPSG:3035',
  })
});

irradiation.id = "irradiation";

// ESRI
/*
let url = 'https://gisserver.gov.si/arcgis/rest/services/DRSV/IKPN_D48/MapServer';

const poplave = new TileLayer({
	visible: false,
	title: "Flooded areas (raster), 10 year frequency",
    source: new TileArcGISRest({      
	  url: url,
	  params: {
		  'layers': 'show:406',
		},
	  projection: 'EPSG:3857',
    }),
  });
  
poplave.id = "floods";
*/
 
/*
const water_protection_areas = new TileLayer({
	visible: false,
	title: "Water protection areas (raster)",
    source: new TileArcGISRest({      
	  url: 'https://gisserver.gov.si/arcgis/rest/services/DRSV/Varstvo_voda_D48/MapServer',
	  params: {
		  'layers': 'show:201',
		},
	  projection: 'EPSG:3912',
    }),
  });
*/

//WFS
// zahteva geslo za podatke
const vectorSource = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  url: function (extent) {
    return (
      'https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=1&service=WFS&' +
      'version=2.0.0&request=GetFeature&' +
	  'typename=SI.GURS.KN:PARCELE&' +
      'outputFormat=application/json&SRSNAME=urn:ogc:def:crs:EPSG:3857&' +
      'bbox=' +
      extent.join(',') +
	  ',urn:ogc:def:crs:EPSG:3857'
    );
  },
  strategy: bboxStrategy,
});

var cadastre = new VectorLayer({
  title: "Cadastral data",
  source: vectorSource,
  visible:true,
  minZoom: 17,
  style: new Style({
	  fill: new Fill({
		  color: 'rgba(0,0,0,0)'	//prosojno
    }),
	stroke: new Stroke({
      color: 'red',
      width: 1.5,
    }),
  }),
});

cadastre.id = "cadastre_si";

// undeground waters 

// old source
/*
const vectorSourceUndergroundWaters = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  crossOrigin: null,
  url: function (extent) {
    return (
      'https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=0&service=WFS&' +
      'version=1.1.0&request=GetFeature&' +
	  'typename=arso:VT_PODZ_VOD_SIST&' +
	  'outputFormat=json&' +
	  'srsname=EPSG:3857&' +
      'bbox=' +
      extent.join(',') +
      ',EPSG:3857'
    );
  },
  strategy: bboxStrategy,
});


var underground_waters = new VectorLayer({
  title: "Groundwater reservoirs",
  source: vectorSourceUndergroundWaters,
  visible: false,
  opacity: 0.5,
  style: new Style({
	  fill: new Fill({
      color: '#ffd9cc',
    }),
    stroke: new Stroke({
      color: 'red',
      width: 3,
    }),
  }),
});
underground_waters.id = "groundwater_reservoirs_si";

*/

// caves

const caves_url = 'https://gis.arso.gov.si/arcgis/rest/services/Atlasokolja_javni_D96/MapServer/';
const caves_num = '199';

const vectorSourceCaves = new VectorSource({
  format: new EsriJSON(),
  url: function (extent, resolution, projection) {
    // ArcGIS Server only wants the numeric portion of the projection ID.
    const srid = projection
      .getCode()
      .split(/:(?=\d+$)/)
      .pop();

    const url =
      caves_url +
      caves_num +
      '/query/?f=json&' +
      'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
      encodeURIComponent(
        '{"xmin":' +
          extent[0] +
          ',"ymin":' +
          extent[1] +
          ',"xmax":' +
          extent[2] +
          ',"ymax":' +
          extent[3] +
          ',"spatialReference":{"wkid":' +
          srid +
          '}}',
      ) +
      '&geometryType=esriGeometryEnvelope&inSR=' +
      srid +
      '&outFields=*' +
      '&outSR=' +
      srid;

    return url;
  },
  strategy: tileStrategy(
    createXYZ({
      tileSize: 512,
    }),
  )
});


/* star vir
const vectorSourceCaves = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  crossOrigin: null,
  url: function (extent) {
    return (
      'https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=0&service=WFS&' +
      'version=1.1.0&request=GetFeature&' +
	  'typename=arso:NV_JAME&' +
	  'outputFormat=json&' +
	  'srsname=EPSG:3857&' +
      'bbox=' +
      extent.join(',') +
      ',EPSG:3857'
    );
  },
  strategy: bboxStrategy,
});
*/

var caves = new VectorLayer({
  title: "Caves",
  source: vectorSourceCaves,
  visible: false,
  opacity: 0.5,
  style: new Style({
	  image: new Circle({
				  radius: 5,
				  fill: null,
				  stroke: new Stroke({color: 'red', width: 1}),
				  fill: new Fill({
							  color: 'purple'
						  })
		}),
    }),
});

caves.id = "caves_si";

/* ESRI JSON */
/* Flood areas */

var serviceUrl =
  'https://gis.arso.gov.si/arcgis/rest/services/Atlasokolja_javni_D96/MapServer/';
var layer = '179';

var esrijsonFormat = new EsriJSON();

var vectorSourceESRI = new VectorSource({
  loader: function (extent, resolution, projection) {
    var url =
      serviceUrl +
      layer +
      '/query/?f=json&' +
      'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
      encodeURIComponent(
        '{"xmin":' +
          extent[0] +
          ',"ymin":' +
          extent[1] +
          ',"xmax":' +
          extent[2] +
          ',"ymax":' +
          extent[3] +
          ',"spatialReference":{"wkid":3857}}'
      ) +
      '&geometryType=esriGeometryEnvelope&inSR=3857&outFields=*' +
      '&outSR=3857';
    $.ajax({
      url: url,
      dataType: 'jsonp',
      success: function (response) {
        if (response.error) {
			console.log(response.error.message + '\n' + response.error.details.join('\n'));          
        } else {
          // dataProjection will be read from document
          var features = esrijsonFormat.readFeatures(response, {
            featureProjection: projection,
          });
          if (features.length > 0) {
            vectorSourceESRI.addFeatures(features);
          }
        }
      },
    });
  },
  strategy: bboxStrategy,
});

var flood_areas_vector = new VectorLayer({
  title: "Flooded areas, 10 year frequency",
  source: vectorSourceESRI,
  minZoom: 10,
  visible: false,
  style: new Style({
    fill: new Fill({
      color: 'DodgerBlue',
    }),
    stroke: new Stroke({
      color: 'Blue',
      width: 0.5,
    }),
  }),
});

flood_areas_vector.id = "floods_vector";

//Undergrond waters
var serviceUrlUndergroundWaters =
  'https://geohub.gov.si/ags/rest/services/DRSV/Vodna_telesa/MapServer/';
var layerUW = '5512';

var esrijsonFormat2 = new EsriJSON();

var vectorSourceESRI2 = new VectorSource({
  loader: function (extent, resolution, projection) {
    var url =
      serviceUrlUndergroundWaters +
      layerUW +
      '/query/?f=json&' +
      'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
      encodeURIComponent(
        '{"xmin":' +
          extent[0] +
          ',"ymin":' +
          extent[1] +
          ',"xmax":' +
          extent[2] +
          ',"ymax":' +
          extent[3] +
          ',"spatialReference":{"wkid":3857}}'
      ) +
      '&geometryType=esriGeometryEnvelope&inSR=3857&outFields=*' +
      '&outSR=3857';
    $.ajax({
      url: url,
      dataType: 'jsonp',
      success: function (response) {
        if (response.error) {
			console.log(response.error.message + '\n' + response.error.details.join('\n'));          
        } else {
          // dataProjection will be read from document
          var features = esrijsonFormat2.readFeatures(response, {
            featureProjection: projection,
          });
          if (features.length > 0) {
            vectorSourceESRI2.addFeatures(features);
          }
        }
      },
    });
  },
  strategy: bboxStrategy,
});

var undergroundWaters = new VectorLayer({
  title: "SI - Groundwater bodies",
  source: vectorSourceESRI2,
  opacity: 0.5,
  //minZoom: 14,
  visible: true,
  style: new Style({
    fill: new Fill({
      color: ' #ffe6cc',
    }),
    stroke: new Stroke({
      color: 'brown',
      width: 3,
    }),
  }),
});

undergroundWaters.id = "underground_bodies_si";

//Water bodies

// Water lines
/*
var serviceUrlWaterBodies =
  'https://gisserver.gov.si/arcgis/rest/services/DRSV/Vodna_telesa/MapServer/';
//var layerUW = '115,116,118';
var layer3 = '115';

var esrijsonFormat3 = new EsriJSON();

var vectorSourceESRI3 = new VectorSource({
  loader: function (extent, resolution, projection) {
    var url =
      serviceUrlWaterBodies +
      layer3 +
      '/query/?f=json&' +
      'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
      encodeURIComponent(
        '{"xmin":' +
          extent[0] +
          ',"ymin":' +
          extent[1] +
          ',"xmax":' +
          extent[2] +
          ',"ymax":' +
          extent[3] +
          ',"spatialReference":{"wkid":3857}}'
      ) +
      '&geometryType=esriGeometryEnvelope&inSR=3857&outFields=*' +
      '&outSR=3857';
    $.ajax({
      url: url,
      dataType: 'jsonp',
      success: function (response) {
        if (response.error) {
			console.log(response.error.message + '\n' + response.error.details.join('\n'));          
        } else {
          // dataProjection will be read from document
          var features = esrijsonFormat3.readFeatures(response, {
            featureProjection: projection,
          });
          if (features.length > 0) {
            vectorSourceESRI3.addFeatures(features);
          }
        }
      },
    });
  },
  strategy: bboxStrategy,
});

var waterBodyLines = new VectorLayer({
  title: "Water bodies - rivers",
  source: vectorSourceESRI3,
  opacity: 0.5,
  visible:false,
  //minZoom: 14,
  style: new Style({
    fill: new Fill({
      color: 'DodgerBlue',
    }),
    stroke: new Stroke({
      color: 'Blue',
      width: 3,
    }),
  }),
});

//Water body lakes
var serviceUrlWaterBodies5 =
  'https://gisserver.gov.si/arcgis/rest/services/DRSV/Vodna_telesa/MapServer/';
//var layerUW = '115,116,118';
var layerUW5 = '118';

var esrijsonFormat5 = new EsriJSON();

var vectorSourceESRI5 = new VectorSource({
  loader: function (extent, resolution, projection) {
    var url =
      serviceUrlWaterBodies5 +
      layerUW5 +
      '/query/?f=json&' +
      'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
      encodeURIComponent(
        '{"xmin":' +
          extent[0] +
          ',"ymin":' +
          extent[1] +
          ',"xmax":' +
          extent[2] +
          ',"ymax":' +
          extent[3] +
          ',"spatialReference":{"wkid":3857}}'
      ) +
      '&geometryType=esriGeometryEnvelope&inSR=3857&outFields=*' +
      '&outSR=3857';
    $.ajax({
      url: url,
      dataType: 'jsonp',
      success: function (response) {
        if (response.error) {
			console.log(response.error.message + '\n' + response.error.details.join('\n'));          
        } else {
          // dataProjection will be read from document
          var features = esrijsonFormat5.readFeatures(response, {
            featureProjection: projection,
          });
          if (features.length > 0) {
            vectorSourceESRI5.addFeatures(features);
          }
        }
      },
    });
  },
  strategy: bboxStrategy,
});

var waterBodyLakes = new VectorLayer({
  title: "Water bodies - lakes",
  source: vectorSourceESRI5,
  opacity: 0.5,
  visible:false,
  //minZoom: 14,
  style: new Style({
    fill: new Fill({
      color: 'DodgerBlue',
    }),
    stroke: new Stroke({
      color: 'Blue',
      width: 1,
    }),
  }),
});

*/

//Vodovarstvena območja
/*
const vodovarUrl = 'https://geohub.gov.si/ags/rest/services/DRSV/Varstvo_voda/MapServer/';
const vodovar_layers = '5362';

const vectorSourceESRI6 = new VectorSource({
  format: new EsriJSON(),
  url: function (extent, resolution, projection) {
    // ArcGIS Server only wants the numeric portion of the projection ID.
    const srid = projection
      .getCode()
      .split(/:(?=\d+$)/)
      .pop();

    const url =
      vodovarUrl +
      vodovar_layers +
      '/query/?f=json&' +
      'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
      encodeURIComponent(
        '{"xmin":' +
          extent[0] +
          ',"ymin":' +
          extent[1] +
          ',"xmax":' +
          extent[2] +
          ',"ymax":' +
          extent[3] +
          ',"spatialReference":{"wkid":' +
          srid +
          '}}',
      ) +
      '&geometryType=esriGeometryEnvelope&inSR=' +
      srid +
      '&outFields=*' +
      '&outSR=' +
      srid;

    return url;
  },
  strategy: tileStrategy(
    createXYZ({
      tileSize: 512,
    }),
  )
});
*/

var vodovarUrl = 'https://geohub.gov.si/ags/rest/services/DRSV/Varstvo_voda/MapServer/';
var vodovar_layers = '5362';

var esrijsonFormat2a = new EsriJSON();

var vectorSourceESRI6 = new VectorSource({
  loader: function (extent, resolution, projection) {
    var url =
      vodovarUrl +
      vodovar_layers +
      '/query/?f=json&' +
      'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
      encodeURIComponent(
        '{"xmin":' +
          extent[0] +
          ',"ymin":' +
          extent[1] +
          ',"xmax":' +
          extent[2] +
          ',"ymax":' +
          extent[3] +
          ',"spatialReference":{"wkid":3857}}'
      ) +
      '&geometryType=esriGeometryEnvelope&inSR=3857&outFields=*' +
      '&outSR=3857';
    $.ajax({
      url: url,
      dataType: 'jsonp',
      success: function (response) {
        if (response.error) {
			console.log(response.error.message + '\n' + response.error.details.join('\n'));          
        } else {
          // dataProjection will be read from document
          var features = esrijsonFormat2a.readFeatures(response, {
            featureProjection: projection,
          });
          if (features.length > 0) {
            vectorSourceESRI6.addFeatures(features);
          }
        }
      },
    });
  },
  strategy: bboxStrategy,
});

var vodovarstvena = new VectorLayer({
  title: "SI - Drinking water safeguard zones (municipality level)",
  source: vectorSourceESRI6,
  opacity: 0.5,
  visible:true,
  //minZoom: 14,
  style: new Style({
    fill: new Fill({
      color: 'DodgerBlue',
    }),
    stroke: new Stroke({
      color: 'Blue',
      width: 1,
    }),
  }),
});

vodovarstvena.id = "drinking_water_si";

//* local layers *//

// pedološka karta
const pedoloska_karta_source = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  crossOrigin: null,
  url: function (extent) {
    return (
      'https://app.gis.si/geoserver/GINST/ows?service=WFS&' +
      'version=1.1.0&request=GetFeature&' +
	  'typename=GINST:pedoloska_karta&' +
	  'outputFormat=json&' +
	  'srsname=EPSG:3857&' +
	  //'propertyName=geom,HA&' +
      'bbox=' +
      extent.join(',') +
      ',EPSG:3857'
    );
  },
  strategy: bboxStrategy,
});

var pedoloska_karta = new VectorLayer({
  title: "SI - Soil map 1:25.000",
  source: pedoloska_karta_source,
  visible: true,
  opacity: 0.5,
  minZoom: 13,
  style: new Style({
	  fill: new Fill({
      color: 'orange',
    }),
    stroke: new Stroke({
      color: 'brown',
      width: 2,
    }),
  }),
});

pedoloska_karta.id = "soil_si";

// območje pogostih poplav
const obmocje_pogostih_poplav_source = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  crossOrigin: null,
  url: function (extent) {
    return (
      'https://app.gis.si/geoserver/GINST/ows?service=WFS&' +
      'version=1.1.0&request=GetFeature&' +
	  'typename=GINST:obmocje_pogostih_poplav&' +
	  'outputFormat=json&' +
	  'srsname=EPSG:3857&' +
      'bbox=' +
      extent.join(',') +
      ',EPSG:3857'
    );
  },
  strategy: bboxStrategy,
});

var obmocje_pogostih_poplav = new VectorLayer({
  title: "Area of frequent floods",
  source: obmocje_pogostih_poplav_source,
  visible: false,
  opacity: 0.5,
  style: new Style({
	  fill: new Fill({
      color: 'DogerBlue',
    }),
    stroke: new Stroke({
      color: 'Blue',
      width: 2,
    }),
  }),
});


// water bodies
const water_bodies_source = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  crossOrigin: null,
  url: function (extent) {
    return (
      'https://app.gis.si/geoserver/GINST/ows?service=WFS&' +
      'version=1.1.0&request=GetFeature&' +
	  'typename=GINST:vodna_telesa&' +
	  'outputFormat=json&' +
	  'srsname=EPSG:3857&' +
      'bbox=' +
      extent.join(',') +
      ',EPSG:3857'
    );
  },
  strategy: bboxStrategy,
});

var water_bodies = new VectorLayer({
  title: "SI - Water bodies",
  source: water_bodies_source,
  visible: true,
  opacity: 0.5,
  style: new Style({
	  fill: new Fill({
      color: 'DodgerBlue',
    }),
    stroke: new Stroke({
      color: 'Blue',
      width: 1,
    }),
  }),
});

water_bodies.id = "water_bodies_si";

// GERK raba local
const gerk_raba_source = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  crossOrigin: null,
  url: function (extent) {
    return (
      'https://app.gis.si/geoserver/GINST/ows?service=WFS&' +
      'version=1.1.0&request=GetFeature&' +
	  'typename=GINST:GERK_raba&' +
	  'outputFormat=json&' +
	  'srsname=EPSG:3857&' +
      'bbox=' +
      extent.join(',') +
      ',EPSG:3857'
    );
  },
  strategy: bboxStrategy,
});

var gerk_raba = new VectorLayer({
  title: "Land use",
  source: gerk_raba_source,
  visible: false,
  opacity: 0.5,
  minZoom: 17,
  style: new Style({
	  fill: new Fill({
      color: 'orange',
    }),
    stroke: new Stroke({
      color: 'brown',
      width: 1,
    }),
  }),
});

gerk_raba.id = "agricultural_si";



// ARSO NATURA 2000

const serviceUrl2 = 'https://gis.arso.gov.si/arcgis/rest/services/Atlasokolja_javni_D96/MapServer/';
const layer2 = '211';

const natura_source = new VectorSource({
  format: new EsriJSON(),
  url: function (extent, resolution, projection) {
    // ArcGIS Server only wants the numeric portion of the projection ID.
    const srid = projection
      .getCode()
      .split(/:(?=\d+$)/)
      .pop();

    const url =
      serviceUrl2 +
      layer2 +
      '/query/?f=json&' +
      'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
      encodeURIComponent(
        '{"xmin":' +
          extent[0] +
          ',"ymin":' +
          extent[1] +
          ',"xmax":' +
          extent[2] +
          ',"ymax":' +
          extent[3] +
          ',"spatialReference":{"wkid":' +
          srid +
          '}}',
      ) +
      '&geometryType=esriGeometryEnvelope&inSR=' +
      srid +
      '&outFields=*' +
      '&outSR=' +
      srid;

    return url;
  },
  strategy: tileStrategy(
    createXYZ({
      tileSize: 512,
    }),
  )
});


/* stari vir WFS
const natura_source = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  crossOrigin: null,
  url: function (extent) {
    return (
      'https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=0&service=WFS&' +
      'version=1.1.0&request=GetFeature&' +
	  'typename=arso:NATURA_2000&' +
	  'outputFormat=json&' +
	  'srsname=EPSG:3857&' +
      'bbox=' +
      extent.join(',') +
      ',EPSG:3857'
    );
  },
  strategy: bboxStrategy,
});
*/

var natura = new VectorLayer({
  title: "Natura 2000",
  source: natura_source,
  visible: false,
  opacity: 0.5,
  //minZoom: 17,
  style: new Style({
	  fill: new Fill({
      color: 'green',
    }),
    stroke: new Stroke({
      color: '#1f7a1f',
      width: 2,
    }),
  }),
});

natura.id = "natura_si";


const serviceUrl2a = 'https://gis.arso.gov.si/arcgis/rest/services/Atlasokolja_javni_D96/MapServer/';
const layer2a = '214';

const eco_areas_source = new VectorSource({
  format: new EsriJSON(),
  url: function (extent, resolution, projection) {
    // ArcGIS Server only wants the numeric portion of the projection ID.
    const srid = projection
      .getCode()
      .split(/:(?=\d+$)/)
      .pop();

    const url =
      serviceUrl2a +
      layer2a +
      '/query/?f=json&' +
      'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
      encodeURIComponent(
        '{"xmin":' +
          extent[0] +
          ',"ymin":' +
          extent[1] +
          ',"xmax":' +
          extent[2] +
          ',"ymax":' +
          extent[3] +
          ',"spatialReference":{"wkid":' +
          srid +
          '}}',
      ) +
      '&geometryType=esriGeometryEnvelope&inSR=' +
      srid +
      '&outFields=*' +
      '&outSR=' +
      srid;

    return url;
  },
  strategy: tileStrategy(
    createXYZ({
      tileSize: 512,
    }),
  )
});


// ARSO Ecologically important areas - old
/*
const eco_areas_source = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  crossOrigin: null,
  url: function (extent) {
    return (
      'https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=0&service=WFS&' +
      'version=1.1.0&request=GetFeature&' +
	  'typename=arso:EPO&' +
	  'outputFormat=json&' +
	  'srsname=EPSG:3857&' +
      'bbox=' +
      extent.join(',') +
      ',EPSG:3857'
    );
  },
  strategy: bboxStrategy,
});
*/

var eco_areas = new VectorLayer({
  title: "Ecologically important areas",
  source: eco_areas_source,
  visible: false,
  opacity: 0.5,
  //minZoom: 17,
  style: new Style({
	  fill: new Fill({
      color: '#99ff99',
    }),
    stroke: new Stroke({
      color: '#1f7a1f',
      width: 1,
    }),
  }),
});

eco_areas.id = "eco_areas";


// ARSO Valuable natural features

const valuable_natural_features_url = 'https://gis.arso.gov.si/arcgis/rest/services/Atlasokolja_javni_D96/MapServer/';
const valuable_natural_features_num = '213';

const valuable_natural_features_source = new VectorSource({
  format: new EsriJSON(),
  url: function (extent, resolution, projection) {
    // ArcGIS Server only wants the numeric portion of the projection ID.
    const srid = projection
      .getCode()
      .split(/:(?=\d+$)/)
      .pop();

    const url =
      valuable_natural_features_url +
      valuable_natural_features_num +
      '/query/?f=json&' +
      'returnGeometry=true&spatialRel=esriSpatialRelIntersects&geometry=' +
      encodeURIComponent(
        '{"xmin":' +
          extent[0] +
          ',"ymin":' +
          extent[1] +
          ',"xmax":' +
          extent[2] +
          ',"ymax":' +
          extent[3] +
          ',"spatialReference":{"wkid":' +
          srid +
          '}}',
      ) +
      '&geometryType=esriGeometryEnvelope&inSR=' +
      srid +
      '&outFields=*' +
      '&outSR=' +
      srid;

    return url;
  },
  strategy: tileStrategy(
    createXYZ({
      tileSize: 512,
    }),
  )
});


/* star vir
const valuable_natural_features_source = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  crossOrigin: null,
  url: function (extent) {
    return (
      'https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=0&service=WFS&' +
      'version=1.1.0&request=GetFeature&' +
	  'typename=arso:NV_POLI&' +
	  'outputFormat=json&' +
	  'srsname=EPSG:3857&' +
      'bbox=' +
      extent.join(',') +
      ',EPSG:3857'
    );
  },
  strategy: bboxStrategy,
});
*/

var valuable_natural_features = new VectorLayer({
  title: "Valuable natural features",
  source: valuable_natural_features_source,
  visible: false,
  opacity: 0.5,
  //minZoom: 17,
  style: new Style({
	  fill: new Fill({
      color: '#339966',
    }),
    stroke: new Stroke({
      color: '#1f7a1f',
      width: 2,
    }),
  }),
});

valuable_natural_features.id = "valuable_si";

// Italian data

// groundwater bodies - ITA
// replaced with WFS
/*
const it_underground_waters = new TileLayer({
  visible: true,
  title: "IT - Groundwater bodies",
  source: new TileWMS({
	url: "https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=3&version=1.3.0&service=wms",
	//url: "https://serviziogc.regione.fvg.it/geoserver/IDROGRAF/wms?version=1.3.0&service=wms",
    params: {
      'layers': 'ACQUE_SOTTERRANEE',
    },
	projection: 'EPSG:4326',
	//projection:projection,
  })
});
*/

// IT cadastre
const it_cadastre = new TileLayer({
  visible: true,
  title: "IT - Cadastre",
  minZoom: 15,
  source: new TileWMS({
	//url: "https://wms.cartografia.agenziaentrate.gov.it/inspire/wms/ows01.php",
	url: "https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=7",
    params: {
      'layers': 'CP.CadastralParcel',},
	//projection: 'EPSG:6706',
	projection:projection_it_1,
  })
});

it_cadastre.id = "cadastre_it";


// IT ortofoto
const it_ortofoto = new TileLayer({
  visible: true,
  title: "IT - Orthophoto",
  source: new TileWMS({
	url: "https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=5&map=/ms_ogc/WMS_v1.3/raster/ortofoto_colore_12.map",
    params: {
      'layers': 'OI.ORTOIMMAGINI.2012.33',
    },
	projection: 'EPSG:4326',
  }),
  minZoom: 15,
});

it_ortofoto.id = "orthophoto_it";

// IT Soil map WFS
const vectorSource_it = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  url: function (extent) {
    return (
      'https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=4&SERVICE=WFS&' +
	  //'https://serviziogc.regione.fvg.it/geoserver/ERSA/wfs?SERVICE=WFS&' +
      'version=2.0.0&request=GetFeature&' +
	  'typename=ERSA:CARTA_SUOLI_GO_TS&' +
      'outputFormat=application/json&SRSNAME=urn:ogc:def:crs:EPSG:4326&' +
      'bbox=' +
      extent.join(',') +
	  ',urn:ogc:def:crs:EPSG:4326'
    );
  },
  strategy: bboxStrategy,
});

var soil_map_it_1 = new VectorLayer({
  title: "IT - Soil map (GO,TS)",
  source: vectorSource_it,
  visible:true,
  opacity: 0.5,
  minZoom: 13,
  style: new Style({
	  fill: new Fill({
      color: 'orange',
    }),
    stroke: new Stroke({
      color: 'brown',
      width: 2,
    }),
  }),
});

soil_map_it_1.id = "soil_go";

// IT Soil map WFS - Pordenone
const vectorSource_it_2 = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  url: function (extent) {
    return (
      'https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=4&SERVICE=WFS&' +
	  //'https://serviziogc.regione.fvg.it/geoserver/ERSA/wfs?SERVICE=WFS&' +
      'version=2.0.0&request=GetFeature&' +
	  'typename=ERSA:CARTA_SUOLI_PN&' +
      'outputFormat=application/json&SRSNAME=urn:ogc:def:crs:EPSG:4326&' +
      'bbox=' +
      extent.join(',') +
	  ',urn:ogc:def:crs:EPSG:4326'
    );
  },
  strategy: bboxStrategy,
});

var soil_map_it_2 = new VectorLayer({
  title: "IT - Soil map (PN)",
  source: vectorSource_it_2,
  visible:true,
  id: "soil_pn",
  opacity: 0.5,
  minZoom: 13,
  style: new Style({
	  fill: new Fill({
      color: 'orange',
    }),
    stroke: new Stroke({
      color: 'brown',
      width: 2,
    }),
  }),
});

soil_map_it_2.id = "soil_pn";

// IT WATER BODIES - Rivers
const vectorSource_it_water_bodies = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  url: function (extent) {	  
	  //extent = transformExtent(extent, 'EPSG:3857','EPSG:4326');
    return (
      //'http://serviziogc.regione.fvg.it/geoserver/IDROGRAF/wfs?' +
	  'https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=6&SERVICE=WFS&' +
	  //'https://serviziogc.regione.fvg.it/geoserver/ERSA/wfs?SERVICE=WFS&' +
      'version=2.0.0&request=GetFeature&' +
	  'typename=IDROGRAF:COM_V_GIS_P_CORSI_ACQUA,IDROGRAF:COM_V_GIS_P_CIS_LAGHI&' +
      'outputFormat=application/json&SRSNAME=urn:ogc:def:crs:EPSG:3857&' +
      'bbox=' +
      extent.join(',') +
	  ',urn:ogc:def:crs:EPSG:3857'
    );
  },
  strategy: bboxStrategy,  
});

var it_water_bodies = new VectorLayer({
  title: "IT - Water Bodies",
  source: vectorSource_it_water_bodies,
  visible:true,
  opacity: 0.5,
  style: new Style({
	  fill: new Fill({
      color: 'DodgerBlue',
    }),
    stroke: new Stroke({
      color: 'Blue',
      width: 1,
    }),
  }),
});

it_water_bodies.id = "water_bodies_it";

// IT - telesa podzemnih vod
const vectorSource_it_underground_bodies = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  url: function (extent) {	  
	  //extent = transformExtent(extent, 'EPSG:3857','EPSG:4326');
    return (
      //'http://serviziogc.regione.fvg.it/geoserver/IDROGRAF/wfs?' +
	  'https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=6&SERVICE=WFS&' +
	  //'https://serviziogc.regione.fvg.it/geoserver/ERSA/wfs?SERVICE=WFS&' +
      'version=2.0.0&request=GetFeature&' +
	  'typename=IDROGRAF:ACQUE_SOTTERRANEE&' +
      'outputFormat=application/json&SRSNAME=urn:ogc:def:crs:EPSG:3857&' +
      'bbox=' +
      extent.join(',') +
	  ',urn:ogc:def:crs:EPSG:3857'
    );
  },
  strategy: bboxStrategy,  
});

var it_underground_bodies = new VectorLayer({
  title: "IT - Groundwater Bodies",
  source: vectorSource_it_underground_bodies,
  visible:true,
  opacity: 0.5,
  style: new Style({
    fill: new Fill({
      color: ' #ffe6cc',
    }),
    stroke: new Stroke({
      color: 'brown',
      width: 3,
    }),
  }),
});

it_underground_bodies.id = "underground_bodies_it";

// IT - zavarovana območja pitne vode
const vectorSource_it_acqua_potabile = new VectorSource({
  visible: false,
  format: new GeoJSON(),
  url: function (extent) {	  
	  //extent = transformExtent(extent, 'EPSG:3857','EPSG:4326');
    return (
      //'http://serviziogc.regione.fvg.it/geoserver/IDROGRAF/wfs?' +
	  'https://app.gis.si/proxy/acquavitis_proxy.php?proxy_id=6&SERVICE=WFS&' +
	  //'https://serviziogc.regione.fvg.it/geoserver/ERSA/wfs?SERVICE=WFS&' +
      'version=2.0.0&request=GetFeature&' +
	  'typename=IDROGRAF:AP_ACQUE_POTABILI&' +
      'outputFormat=application/json&SRSNAME=urn:ogc:def:crs:EPSG:3857&' +
      'bbox=' +
      extent.join(',') +
	  ',urn:ogc:def:crs:EPSG:3857'
    );
  },
  strategy: bboxStrategy,  
});

var it_acqua_potabile = new VectorLayer({
  title: "IT - Drinking water safeguard zones",
  source: vectorSource_it_acqua_potabile,
  visible:true,
  opacity: 0.5,
  style: new Style({
    fill: new Fill({
      color: 'DodgerBlue',
    }),
    stroke: new Stroke({
      color: 'Blue',
      width: 1,
    }),
  }),
});

it_acqua_potabile.id = "drinking_water_it";

// SI/IT - common layers
var common_underground_bodies_layers = [undergroundWaters];											
page_profile == 0 && common_underground_bodies_layers.push(it_underground_bodies);

const common_underground_bodies = new LayerGroup({title: 'Groundwater bodies', 
								visible: false, 
								openInLayerSwitcher: false,
								layers: common_underground_bodies_layers
							});

var common_cadastre_layers = [cadastre];
page_profile == 0 && common_cadastre_layers.push(it_cadastre);										
	
const common_cadastre = new LayerGroup({title: 'Cadastral data', 
								visible: false, 
								openInLayerSwitcher: false,
								layers: common_cadastre_layers
							});
							
var common_orthophoto_layers = [dof5];
page_profile == 0 && common_orthophoto_layers.push(it_ortofoto);
							
const common_orthophoto = new LayerGroup({title: 'Orthophoto', 
								visible: true, 
								openInLayerSwitcher: false,
								layers: common_orthophoto_layers
							});

var common_soil_map_layers = [pedoloska_karta];
page_profile == 0 && common_soil_map_layers.push(soil_map_it_1,
											soil_map_it_2);

const common_soil_map = new LayerGroup({title: 'Soil map',
								visible: false, 
								openInLayerSwitcher: false,
								layers: common_soil_map_layers
							});
							
var common_water_bodies_layers = [water_bodies];
page_profile == 0 && common_water_bodies_layers.push(it_water_bodies);							
							
const common_water_bodies = new LayerGroup({title: 'Water bodies', 
								visible: false, 
								openInLayerSwitcher: false,
								layers: common_water_bodies_layers
							});

var common_drinking_water_layers = [vodovarstvena];
page_profile == 0 && common_drinking_water_layers.push(it_acqua_potabile);
							
const common_drinking_water = new LayerGroup({title: 'Drinking water safeguard zones', 
								visible: false, 
								openInLayerSwitcher: false,
								layers: common_drinking_water_layers
							});

var layerGroupLayers = (page_profile == 0) ? [	/*common_orthophoto,*/
											hillshade,
											slope_reclass,
											slope,
											irradiation,
											valuable_natural_features,
											eco_areas,
											natura,
											gerk2,
											gerk_raba,											
											//cadastre,
											//it_cadastre,
											common_cadastre,
											caves,
											//vodovarstvena,
											common_drinking_water,
											//underground_waters,
											//it_underground_waters,
											//poplave, 
											flood_areas_vector,
											common_underground_bodies,
											//undergroundWaters, 
											common_water_bodies,
											/*waterBodyLines, 
											waterBodyLakes,*/
											obmocje_pogostih_poplav, 
											common_soil_map]
									:   
										[	/*common_orthophoto,*/											
											valuable_natural_features,
											eco_areas,natura,
											gerk2,			
											common_cadastre,
											caves,
											common_drinking_water,
											flood_areas_vector,
											common_underground_bodies,
											common_water_bodies,
											obmocje_pogostih_poplav, 
											common_soil_map]
										
										
											

			
const slo_wms = new LayerGroup({title: 'Environmental and other data layers', 
								visible: true, 
								openInLayerSwitcher: false,
								layers: layerGroupLayers
							});
								
//popup array
const popup_array = [	valuable_natural_features,
						eco_areas,
						natura,
						gerk_raba,
						vineyardsLayer,
						cadastre,
						it_cadastre,
						vodovarstvena,
						//underground_waters,
						//poplave,
						flood_areas_vector,
						undergroundWaters,
						it_underground_bodies,
						water_bodies,
						it_water_bodies,
						it_acqua_potabile,
						/*waterBodyLines,
						waterBodyLakes,*/
						obmocje_pogostih_poplav,
						pedoloska_karta,
						soil_map_it_1,
						soil_map_it_2,
						//raster
						gerk2,
						slope,
						slope_reclass,
						irradiation,
						caves];

export {osm, slo_wms, gerk_mask, vineyardsLayer, popup_array, profile_settings, page_profile, common_orthophoto }
